import { gql } from "@/services/httpAdapter.ts";

import { FinanceDetailFragment } from "./fragments.ts";

export const onUpdateFinanceDetails = gql`
	subscription onUpdateFinanceDetails($commissionCycleId: String!, $payPeriodId: String!) {
		onUpdateFinanceDetails(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
			financeDetails {
				...FinanceDetail
			}
		}
	}
	${FinanceDetailFragment}
`;
